// extracted by mini-css-extract-plugin
export default {"tabbar":"aNLgI","tabbar__wrapper":"dIPx0","tabbar__button":"dIcAn","tabbar_position_default":"bg2Kg","tabbar_position_fixed":"pRt4L"};